<template>
  <div class="order-waiting-container">
    <div class="main-content">
      <div class="waiting-card">
        <div class="waiting-header">
          <div class="waiting-title">订单处理中</div>
          <div class="waiting-subtitle"></div>
        </div>
        <!-- 加载动画 -->
        <div class="loading-section">
          <van-loading type="spinner" size="2rem" color="#ff6b6b" />
          <div class="loading-text">{{ loadingText }}</div>
        </div>
        <!-- 订单信息 -->
        <div class="order-info" v-if="orderInfo">
          <div class="info-header">
            <span class="info-icon">📋</span>
            <span class="info-title">订单信息</span>
          </div>
          <div class="info-content">
            <div class="info-item">
              <span class="info-label">订单号</span>
              <span class="info-value">{{ orderInfo.orderNo }}</span>
              <span class="copy-btn" @click.stop="copyOrderNo(orderInfo.orderNo)">复制</span>
            </div>
          </div>
        </div>
        <!-- 提示信息 -->
        <div class="tip-section">
          <div class="tip-icon">💡</div>
          <div class="tip-content">
            <h3 class="tip-title">温馨提示</h3>
            <p class="tip-text">系统正在处理您的订单，请耐心等待</p>
            <p class="tip-text">处理完成后将自动跳转到支付页面</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import utils from '@/utils';

export default {
  name: 'submitOrderWaiting',
  data() {
    return {
      orderInfo: null,
      isProcessing: true,
      loadingText: '请稍候，正在为您处理订单...',
      queryTimer: null,
      queryCount: 0,
      maxQueryCount: 20, // 最大查询次数（10秒，每500毫秒查询一次）
      queryInterval: 500, // 查询间隔（毫秒）
      orderNo: '', // 订单号
      orderCode: '', // 蛋叔三方订单号
    }
  },
  
  mounted() {
    this.initOrderWaiting();
  },
  
  beforeDestroy() {
    this.clearQueryTimer();
  },
  
  methods: {
    // 复制订单号
    copyOrderNo(orderNo) {
      utils.copyText(orderNo, this);
    },
    // 初始化订单等待
    initOrderWaiting() {
      // 从路由参数获取订单信息
      this.orderNo = this.$route.query.orderNo;
      this.orderCode = this.$route.query.order_code || this.$route.query.orderCode;

      // 蛋叔 H5 回跳：带 order_code，落本地单后进统一收银台
      if (this.orderCode) {
        this.orderInfo = {
          orderNo: this.orderCode,
        };
        this.initDsH5Cashier();
        return;
      }

      if (!this.orderNo) {
        Toast('必要参数缺失');
        this.goBack();
        return;
      }

      // 设置基本订单信息
      this.orderInfo = {
        orderNo: this.orderNo,
      };

      // 开始查询订单状态
      this.startQueryOrder();
    },
    // 蛋叔 H5 落单后进入收银台
    async initDsH5Cashier() {
      this.loadingText = '请稍候，正在为您处理订单...';
      try {
        const response = await this.$api.dsH5CashierInit(this.orderCode);
        if (response.code === 0 && response.data) {
          this.handleOrderReady(response.data);
        } else {
          this.isProcessing = false;
          this.loadingText = '订单创建失败';
          Toast(response.msg || '订单创建失败');
          setTimeout(() => {
            this.goBack();
          }, 3000);
        }
      } catch (error) {
        this.isProcessing = false;
        this.loadingText = '订单创建失败';
        Toast('订单创建失败，请稍后重试');
        setTimeout(() => {
          this.goBack();
        }, 3000);
      }
    },
    // 开始查询订单状态
    startQueryOrder() {
      this.queryOrderStatus();
      this.queryTimer = setInterval(() => {
        this.queryCount++;
        if (this.queryCount >= this.maxQueryCount) {
          this.handleQueryTimeout();
          return;
        }
        this.queryOrderStatus();
      }, this.queryInterval);
    },
    // 查询订单状态
    async queryOrderStatus() {
      try {
        // 调用API查询订单状态
        const response = await this.$api.checkOrderCreationComplete(this.orderNo);
        if (response.code === 0) {
          // 订单查询成功，跳转到支付页面
          this.handleOrderReady(response.data);
        } else {
          // 订单还未准备好，继续等待
          // console.log('订单处理中，继续等待...');
        }
      } catch (error) {
        // console.error('查询订单状态失败:', error);
        // 网络错误等，继续重试
      }
    },
    // 订单准备完成，跳转到支付页面
    handleOrderReady(orderNo) {
      this.clearQueryTimer();
      this.isProcessing = false;
      Toast.success('订单处理完成');
      
      // 统一跳转到统一支付页面
      setTimeout(() => {
        this.$router.replace({
          path: '/UnifiedCashier',
          query: {
            orderNo: orderNo
          }
        });
      }, 1000);
    },
    // 查询超时处理
    handleQueryTimeout() {
      this.clearQueryTimer();
      this.isProcessing = false;
      this.loadingText = '订单处理超时';
      Toast('订单处理超时，请稍后重试');
      setTimeout(() => {
        this.goBack();
      }, 3000);
    },
    // 清除查询定时器
    clearQueryTimer() {
      if (this.queryTimer) {
        clearInterval(this.queryTimer);
        this.queryTimer = null;
      }
    },
    // 返回上一页
    goBack() {
      if (this.$route.query.from) {
        this.$router.replace(this.$route.query.from);
      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-waiting-container {
  background-color: #f7f8fa;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.main-content {
  width: 100%;
  max-width: 24rem;
}

.waiting-card {
  background-color: #ffffff;
  border-radius: 1rem;
  padding: 2.5rem 2rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.waiting-header {
  margin-bottom: 2rem;
}

.waiting-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333333;
  margin-bottom: 0.5rem;
}

.waiting-subtitle {
  font-size: 0.9rem;
  color: #666666;
  margin: 0;
  line-height: 1.4;
}

.loading-section {
  margin-bottom: 2rem;
}

.loading-text {
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #666666;
}

.order-info {
  background-color: #f8f9fa;
  border-radius: 0.8rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid #e9ecef;
}

.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}

.info-icon {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

.info-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333333;
}

.info-content {
  text-align: left;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.info-label {
  font-size: 0.9rem;
  color: #666666;
  font-weight: 500;
}

.info-value {
  font-size: 0.9rem;
  color: #333333;
  font-weight: 600;
}

.tip-section {
  background-color: #fff3cd;
  border-radius: 0.8rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid #ffeaa7;
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.tip-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
  margin-top: 0.1rem;
}

.tip-content {
  flex: 1;
}

.tip-title {
  font-size: 1rem;
  font-weight: 600;
  color: #856404;
  margin: 0 0 0.5rem 0;
}

.tip-text {
  font-size: 0.9rem;
  color: #856404;
  line-height: 1.5;
  margin: 0;
}

.action-section {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.action-btn {
  flex: 1;
  min-width: 8rem;
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 0.8rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  &:active {
    transform: scale(0.98);
  }
}

.action-btn.primary {
  background-color: #ff6b6b;
  color: white;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
  &:hover {
    background-color: #ff5252;
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
  }
}

.action-btn.secondary {
  background-color: #f8f9fa;
  color: #666666;
  border: 1px solid #e9ecef;
  &:hover {
    background-color: #e9ecef;
    color: #333333;
  }
}

.btn-icon {
  font-size: 1rem;
}

.btn-text {
  font-weight: 600;
}

.copy-btn {
  margin-left: 0.5rem;
  padding: 0.1rem 0.4rem;
  background: rgba(102, 102, 102, 0.1);
  color: #666;
  font-size: 0.75rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(102, 102, 102, 0.3);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: inline-block;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.copy-btn:active {
  background: rgba(102, 102, 102, 0.2) !important;
  transform: scale(0.95) !important;
}

@media (max-width: 480px) {
  .waiting-card {
    padding: 2rem 1.5rem;
  }
  .action-section {
    flex-direction: column;
  }
  .action-btn {
    min-width: auto;
  }
}
</style>
